var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "cd26d598a9b6a1de74dea9a9e9916d8f1a770fc2"
};